module.exports = __webpack_public_path__ + "img/chabei.6c8fa904.png";